import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-checkboxes' })
export class FormCheckboxesComponent {
	private sameInputs: HTMLInputElement[];

	constructor(private element: HTMLElement) {
		this.sameInputs = Array.from(
			this.element.querySelectorAll(`input[type="checkbox"]`)
		) as HTMLInputElement[];

		if (this.sameInputs && this.sameInputs.length > 0) {
			if (this.element.hasAttribute('data-required')) {
				this.sameInputs.forEach((input) => {
					input.addEventListener('change', () => {
						this.checkRequired();
					});
				});

				this.checkRequired();
				this.scrollToSelected();
			}
		}
	}

	private scrollToSelected() {
		const firstChecked = this.sameInputs.find((o) => o.checked);
		if (firstChecked) {
			this.element.scrollTo(
				0,
				firstChecked.parentElement.offsetTop -
					firstChecked.parentElement.offsetHeight -
					parseInt(getComputedStyle(this.element).marginTop)
			);
		}
	}

	private checkRequired() {
		const hasSomeChecked = this.sameInputs.some((o) => o.checked);
		this.sameInputs.forEach((o) => (o.required = hasSomeChecked == false));
	}
}
